import { render } from "./ScheduleSetupTableEmptyState.vue?vue&type=template&id=36cbf665"
import script from "./ScheduleSetupTableEmptyState.vue?vue&type=script&lang=js"
export * from "./ScheduleSetupTableEmptyState.vue?vue&type=script&lang=js"

import "./ScheduleSetupTableEmptyState.vue?vue&type=style&index=0&id=36cbf665&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__